import { Box, Button, Typography } from "@mui/material";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { deleteEnvio, type Envio } from "../../firebase/firestore/envios";
import { UserRole } from "../../interfaces/UserRole";
import { useAuthStore } from "../../zustand/useAuthStore";
import { useEnvioStore } from "../../zustand/useEnviosStore";
import Modal from "./Modal";

interface ModalDeleteShipmentProps {
  isOpen: boolean;
  onClose: () => void;
  envio?: Envio;
}

export default function ModalDeleteShipment({
  isOpen,
  onClose,
  envio,
}: ModalDeleteShipmentProps) {
  const { fetchAllEnvios } = useEnvioStore();
  const { user } = useAuthStore();

  useEffect(() => {
    // Verificar permisos al abrir el modal
    if (isOpen && user?.role !== UserRole.Admin) {
      toast.error("No tienes permisos para eliminar envíos");
      onClose();
    }
  }, [isOpen, user, onClose]);

  const handleDelete = async () => {
    if (!envio) return;

    // Verificación adicional de permisos
    if (user?.role !== UserRole.Admin) {
      toast.error("No tienes permisos para eliminar envíos");
      onClose();
      return;
    }

    try {
      await deleteEnvio(envio.id);
      toast.success("Envío eliminado exitosamente");
      onClose();
      await fetchAllEnvios();
    } catch (error) {
      console.error("Error eliminando envío:", error);
      toast.error("Error al eliminar el envío. Intente nuevamente");
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Eliminar envío"
      content={
        <Box
          sx={{
            paddingX: "24px",
            marginBottom: 2,
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <Typography>
            {envio
              ? `El envío "${envio.nombre}" será eliminado permanentemente. Si hay paquetes con este envío asignado, se les eliminará el campo de envío. ¿Estás seguro que deseas continuar?`
              : "¿Estás seguro que deseas eliminar este envío?"}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button onClick={onClose} variant="outlined" size="small">
              Cancelar
            </Button>
            <Button
              onClick={handleDelete}
              variant="contained"
              color="error"
              size="small"
            >
              Eliminar
            </Button>
          </Box>
        </Box>
      }
      sx={{
        marginX: "auto",
        width: {
          xs: "90%",
          sm: "50%",
        },
      }}
    />
  );
}
